document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.search-form').forEach((form) => {
    let changeHandler = (evt) => {
      if (evt.currentTarget.value) {
        form.querySelector('.search-form-submit').removeAttribute('disabled')
      } else {
        form.querySelector('.search-form-submit').setAttribute('disabled', true)
      }
    }
    ['change', 'keyup'].forEach((evtName) => {
      form.querySelector('.search-form-input').addEventListener(evtName, changeHandler);
    })
  })
})